import { Fragment } from 'react'
import Box from '@mui/material/Box'
import trustNoApp from '../assets/welcome/trust-no-app.svg'
import trustNoPurchase from '../assets/welcome/trust-no-purchase.svg'
import trustNoCard from '../assets/welcome/trust-no-card.svg'
import trustSecure from '../assets/welcome/trust-secure.svg'
import trustConfidential from '../assets/welcome/trust-confidential.svg'
import trustMobile from '../assets/welcome/trust-mobile.svg'
import {
  welcomeTrustCardSx,
  welcomeTrustDesktopSx,
  welcomeTrustDotSx,
  welcomeTrustGridSx,
  welcomeTrustItemSx,
  welcomeTrustRowSx,
  welcomeTrustWrapSx,
} from '../styles/signupSurveyWelcomeStyles'

const TRUST_ITEMS = [
  { src: trustNoApp, label: 'No app download', shortLabel: 'No app download' },
  { src: trustNoPurchase, label: 'No purchase required', shortLabel: 'No purchase' },
  { src: trustNoCard, label: 'No credit card required', shortLabel: 'No credit card' },
  { src: trustSecure, label: 'Secure', shortLabel: 'Secure' },
  { src: trustConfidential, label: 'Confidential', shortLabel: 'Confidential' },
  { src: trustMobile, label: 'Mobile friendly', shortLabel: 'Mobile friendly' },
] as const

const PRIMARY = TRUST_ITEMS.slice(0, 3)
const SECONDARY = TRUST_ITEMS.slice(3)

function TrustRow({
  items,
}: {
  readonly items: readonly { src: string; label: string }[]
}) {
  return (
    <Box sx={welcomeTrustRowSx}>
      {items.map((item, index) => (
        <Fragment key={item.label}>
          {index > 0 ? <Box sx={welcomeTrustDotSx} aria-hidden /> : null}
          <Box sx={welcomeTrustItemSx}>
            <Box component="img" src={item.src} alt="" />
            {item.label}
          </Box>
        </Fragment>
      ))}
    </Box>
  )
}

export function SignupSurveyWelcomeTrust() {
  return (
    <Box sx={welcomeTrustWrapSx} data-testid="signup-survey-welcome-trust">
      <Box sx={welcomeTrustGridSx}>
        {TRUST_ITEMS.map((item) => (
          <Box key={item.shortLabel} sx={welcomeTrustCardSx}>
            <Box component="img" src={item.src} alt="" />
            {item.shortLabel}
          </Box>
        ))}
      </Box>
      <Box sx={welcomeTrustDesktopSx}>
        <TrustRow items={PRIMARY} />
        <TrustRow items={SECONDARY} />
      </Box>
    </Box>
  )
}
